import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useI18n } from "@/contexts/i18n";
import { useFeaturesEnabled } from "@/contexts/cdpConfig";
import { useBrandContext } from "@/shared/contexts";
export const LegalText = () => {
    const { legal: { link1, link2, link3 }, } = useBrandContext();
    const { t } = useI18n();
    const { openedContactForm } = useFeaturesEnabled();
    const lokalised = t("contact.form.legal_text.body");
    const textWithLinks = lokalised
        .replace("{link1}", `<a target="_blank" href="${link1.href}">${t("contact.form.legal_text.link_label_one")}</a>`)
        .replace("{link2}", `<a target="_blank" href="${link2.href}">${t("contact.form.legal_text.link_label_two")}</a>`)
        .replace("{link3}", `<a target="_blank" href="${link3.href}">${t("contact.form.legal_text.link_label_three")}</a>`);
    return (_jsx(Box, { paddingTop: openedContactForm ? 0 : "spacing.12", typography: "typography.body.11.regular", marginBottom: {
            "breakpoint.xs": openedContactForm ? "spacing.40" : "spacing.128",
            "breakpoint.md": "0",
        }, dangerouslySetInnerHTML: { __html: textWithLinks } }));
};
